import * as angular from 'angular';
import * as angularResource from 'angular-resource';

import { common } from '../common';
import { mediaModel } from '../media';

import { SyncEvent } from './sync-event.factory';
import { syncEventServiceTransformer } from './sync-event-transformer.service';
import { syncEventServiceInterceptor } from './sync-event-interceptor.service';
import { ng1FormatTimePipe } from '@go-modules/pipes/format-time/format-time.pipe';

export const syncEventModel = angular.module('go.models.syncEvent', [
	angularResource,
	common,
	mediaModel
])
	.service('syncEventServiceInterceptor', syncEventServiceInterceptor)
	.service('syncEventServiceTransformer', syncEventServiceTransformer)
	.factory('SyncEvent', SyncEvent)
	.filter('ng1FormatTime', ng1FormatTimePipe)
	.name;
